
import { Injectable } from '@angular/core';;
import { Action } from '@ngrx/store';
import { LoadEinConfigurationState, LoadEinConfigurationStateSuccess, LoadEinConfigurationStateFail, EinConfigurationActionTypes, SaveEINOrgDetail, SaveEINOrgDetailSuccess } from './ein-configuration.actions';
import { IEinConfiguration, LGEDataService } from '../../../commons';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, from, catchError, map, of } from 'rxjs';

@Injectable()
export class EinConfigurationEffects {

  loadEinConfigurationState$ = createEffect(
    () => this.actions$.pipe(
      ofType(EinConfigurationActionTypes.LoadEinConfigurationState),
      switchMap(
        () => from(this.lgeDataService.GetEINOrgInfoDetail()).pipe(
          map((state: IEinConfiguration[]) => new LoadEinConfigurationStateSuccess(state)),
          catchError(error => of(new LoadEinConfigurationStateFail(error)))
        )
      )
    )
  )

  saveEINOrgDetail$ = createEffect(
    () => this.actions$.pipe(
      ofType(EinConfigurationActionTypes.SaveEINOrgDetail),
      map((action: SaveEINOrgDetail) => action.payload),
      switchMap(
        (einOrgDetail) => from(this.lgeDataService.EINOrgInfoDetailIUD(einOrgDetail)).pipe(
          map((state: IEinConfiguration[]) => new LoadEinConfigurationStateSuccess(state)),
        )
      ),
      switchMap(
        () => [new SaveEINOrgDetailSuccess(), new LoadEinConfigurationState()]
      ),
      catchError(error => of(new LoadEinConfigurationStateFail(error)))
    )
  )


  constructor(
    private actions$: Actions,
    private lgeDataService: LGEDataService
  ) { }
}